angular.module('callX').controller('IntegrationsMailChimpCtrl', ['$scope', 'UserService','$rootScope','$window','toaster', 'MailChimpService','$state', 'DateService','$location', function($scope,UserService,$rootScope,$window, toaster, MailChimpService,$state, DateService, $location) {

    var currentUserData = UserService.getCurrentUserData();
    $scope.addListCampaign = {};
    $scope.addMailChimpList = {};
    $scope.newList = {};
    $scope.loadingDetailsContent = false;
    $scope.orderParam = '';
    $scope.showAuthorizeForm = 0;
    $scope.customerId = {};
    $scope.companyName = {};
    $scope.tableContentLoading = false;
    $scope.noData = false;

    $scope.userOrderParam = 'revenue';
    $scope.userReverse = true;
    $scope.usersOrder = function(orderParam) {
        $scope.userReverse = ($scope.userOrderParam === orderParam) ? !$scope.userReverse : false;
        $scope.userOrderParam = orderParam;
    };

    // console.log(document.location,"this is the document location");
    // console.log($location,"this is the $location");
    // console.log($window.location,"this is the window location")
    //document.location.search = '';
    //$window.location.search = '';
    //$location.search('?', null);
    $scope.activateMailChimp=function() {
      var client_id="827100097108";
      var scope="email";
      var redirect_uri="https://publisher.callx.com";
      //var redirect_uri="http://52.43.226.123:8081";
      //var redirect_uri="http://127.0.0.1";
      var response_type="code";
      var url="https://login.mailchimp.com/oauth2/authorize?response_type="+response_type+"&client_id="+client_id+"&redirect_uri="+redirect_uri;
      $window.location.replace(url);
     };
     //http://52.43.226.123:8080/japi/mailchimp/4/requestToken?accesscode=8bd4a2a24823144989b9c8934d973be4

    
    $scope.getPublisherStatus = function(){
        $scope.tableContentLoading = true;
       var currentUserData = UserService.getCurrentUserData();
       //var userId = $scope.currentUserData.user_id;
       //console.log($scope.currentUserData,"$scope.currentUserData this is")
       var callbacks = {
            success: function(data) {
//                console.log("this is publisher status",data);
                if(data.data.authenticated == true){
                    $state.go("app.integrations.mailchimp-auth-callback");
                }
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getStatus(currentUserData.id ,callbacks);
     };

     

    if(currentUserData.id!=undefined){
//        console.log("entered here in currentUserData.id!=undefined")
        $scope.getPublisherStatus();
    }; 

    $scope.$on('currentUserUpdate', function(event, userData) {
//        console.log("entered here in $scope.$on")
        currentUserData = userData;
        $scope.getPublisherStatus();
    });

    $scope.formReset = function(){
        $scope.addListCampaign.selected = undefined;
        $scope.addMailChimpList.selected = undefined;
    };
}]);